import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import TrustBar from "@/pages/home/components/TrustBar";
import AIAnswerBlock from "@/pages/home/components/AIAnswerBlock";
import ProcessSection from "@/pages/home/components/ProcessSection";
import WhyChooseUs from "@/pages/home/components/WhyChooseUs";
import TestimonialsSection from "@/pages/home/components/TestimonialsSection";
import FAQSection from "@/pages/home/components/FAQSection";
import FinalCTA from "@/pages/home/components/FinalCTA";
import MidPageCTA from "@/pages/home/components/MidPageCTA";
import QuoteForm from "@/pages/home/components/QuoteForm";
import { locationFaqs } from "@/mocks/faqs";
import { Link } from "react-router-dom";

const dallasAreas = [
  "McKinney", "Uptown Dallas", "Downtown Dallas", "Oak Cliff", "East Dallas",
  "Lake Highlands", "Preston Hollow", "North Dallas", "Irving", "Garland",
  "Richardson", "Plano", "Mesquite", "Frisco", "Allen",
];

const locationQA = [
  {
    q: "Do you provide AC services in Dallas?",
    a: "Yes — Knight In Shining Armor Heating & Air provides full AC repair, installation, and maintenance across Dallas and the surrounding metro area. We serve both residential and commercial properties with same-day service for urgent cooling needs throughout the Dallas area.",
  },
  {
    q: "Why is professional AC service especially critical in Dallas?",
    a: "Dallas regularly sees temperatures above 100°F from June through September. Under that load, HVAC systems face extreme stress. Proper installation, proactive maintenance, and fast emergency repair aren't just comfort matters — they're safety priorities. KISA is built specifically for the Texas climate.",
  },
];

const serviceList = [
  { icon: "ri-temp-cold-line", title: "AC Repair", desc: "Fast, accurate diagnostics and repairs for all AC brands and models." },
  { icon: "ri-tools-line", title: "AC Installation", desc: "Properly sized, high-efficiency system installations for homes and businesses." },
  { icon: "ri-shield-check-line", title: "Preventative Maintenance", desc: "Annual tune-ups to prevent breakdowns and extend system lifespan." },
  { icon: "ri-alarm-warning-line", title: "Emergency HVAC", desc: "Same-day emergency response when your cooling fails in peak heat." },
  { icon: "ri-cloud-windy-line", title: "Air Duct Cleaning", desc: "Improve indoor air quality and system efficiency with professional duct cleaning." },
  { icon: "ri-fire-line", title: "Furnace & Heating", desc: "Complete heating system repair and replacement for cooler months." },
];

export default function LocationDallasPage() {
  return (
    <main className="bg-[#020B14]">
      <Header />

      {/* Hero */}
      <section className="relative w-full min-h-[620px] flex items-center pt-20 overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/d389f8e25bb45f9c5f329bc23112ef61.jpg"
          alt="Air Conditioning Services Dallas TX — Knight In Shining Armor HVAC"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#020B14]/94 via-[#020B14]/78 to-[#020B14]/28" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#020B14]/40 via-transparent to-[#020B14]/72" />
        <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-[#0EA5E9]/50 via-[#38bdf8]/20 to-transparent" />

        <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 py-24">
          <div className="max-w-[640px]">
            <nav className="flex items-center gap-2 mb-7" aria-label="breadcrumb">
              <Link to="/" className="font-['Inter'] text-white/40 text-xs hover:text-white/65 transition-colors duration-300">Home</Link>
              <i className="ri-arrow-right-s-line text-white/22 text-xs"></i>
              <span className="font-['Inter'] text-[#7DD3FC] text-xs">Dallas, TX</span>
            </nav>
            <div className="inline-flex items-center gap-2 border border-[#0EA5E9]/35 bg-[#0EA5E9]/8 rounded-full px-4 py-2 mb-7">
              <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                <i className="ri-map-pin-2-line text-[#7DD3FC] text-xs"></i>
              </div>
              <span className="font-['Inter'] text-[#7DD3FC] text-xs font-medium tracking-[0.15em] uppercase whitespace-nowrap">
                Serving Dallas &amp; DFW Metro
              </span>
            </div>
            <h1 className="font-['Playfair_Display'] text-white text-4xl md:text-5xl lg:text-[3.4rem] font-bold leading-[1.1] mb-6">
              Air Conditioning Services<br className="hidden md:block" /> in Dallas, TX
            </h1>
            <p className="font-['Inter'] text-white/65 text-lg md:text-xl leading-[1.78] mb-10">
              Professional HVAC repair, installation, and maintenance — engineered for Dallas summers and delivered by certified technicians based right here in the metro.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="#quote"
                className="inline-flex items-center justify-center gap-2 bg-white text-[#0a1f3c] hover:bg-gray-50 font-['Inter'] font-bold text-[0.95rem] px-9 py-4 rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer shadow-[0_8px_28px_rgba(255,255,255,0.10)] hover:-translate-y-[1.5px]"
              >
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-2-line text-[#1e3a5f]"></i>
                </div>
                Get Service in Dallas
              </a>
              <a
                href="tel:2148703185"
                className="inline-flex items-center justify-center gap-2 bg-white/6 hover:bg-white/12 border border-white/25 text-white font-['Inter'] font-semibold text-[0.95rem] px-9 py-4 rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm"
              >
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-fill text-[#7DD3FC] text-sm"></i>
                </div>
                Call 214-870-3185
              </a>
            </div>
          </div>
        </div>
      </section>

      <TrustBar />

      {/* Local Expertise Content */}
      <section className="bg-[#050F1A] py-28">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <p className="font-['Inter'] text-[#7DD3FC] text-xs font-semibold uppercase tracking-[0.18em] mb-4">Local Expertise</p>
              <h2 className="font-['Playfair_Display'] text-white text-4xl md:text-[2.9rem] font-bold mb-7 leading-[1.12]">
                Cooling Solutions Engineered<br className="hidden md:block" /> for Dallas Summers
              </h2>
              <p className="font-['Inter'] text-white/58 text-base leading-[1.9] mb-5">
                Dallas summers are relentless. Temperatures routinely exceed 100°F from June through September, placing extreme stress on residential and commercial cooling systems. KISA Cooling provides professional AC repair, installation, and maintenance services designed specifically for the Texas climate.
              </p>
              <p className="font-['Inter'] text-white/58 text-base leading-[1.9] mb-8">
                Our metro-based technicians understand the unique demands that Dallas heat and humidity place on HVAC equipment. We provide rapid-response diagnostics, transparent recommendations, and high-efficiency solutions that keep you comfortable every season.
              </p>
              <div className="flex flex-wrap gap-2.5">
                {["AC Repair", "AC Installation", "Emergency HVAC", "Preventative Maintenance", "Air Duct Cleaning", "Furnace Repair"].map((tag) => (
                  <Link
                    key={tag}
                    to="/services"
                    className="font-['Inter'] text-white/60 hover:text-white text-xs border border-white/10 hover:border-[#0EA5E9]/40 hover:bg-[#0EA5E9]/6 px-4 py-2 rounded-full transition-all duration-300 whitespace-nowrap"
                  >
                    {tag}
                  </Link>
                ))}
              </div>
            </div>
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=hvac%20technician%20confidently%20working%20on%20rooftop%20commercial%20air%20conditioning%20unit%20dallas%20texas%20city%20skyline%20visible%20background%20summer%20heat%20dramatic%20sky%20professional%20experienced%20clean%20uniform%20sharp%20detail%20high%20resolution%20premium%20photography&width=700&height=520&seq=kisa-loc-tech-v3&orientation=landscape"
                alt="KISA HVAC service in Dallas TX"
                className="w-full h-[420px] object-cover object-top rounded-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="bg-[#030c15] py-24">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-end mb-14">
            <div>
              <p className="font-['Inter'] text-[#7DD3FC] text-xs font-semibold uppercase tracking-[0.18em] mb-4">Services in Dallas</p>
              <h2 className="font-['Playfair_Display'] text-white text-4xl font-bold leading-tight">
                Full-Service HVAC for Dallas Properties
              </h2>
            </div>
            <div>
              <p className="font-['Inter'] text-white/50 text-base leading-[1.8]">
                Every cooling and heating service your home or business needs — performed by certified Dallas-area technicians.
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-12">
            {serviceList.map((item) => (
              <div key={item.title} className="bg-[#071220] border border-white/6 rounded-2xl p-7 hover:border-[#0EA5E9]/28 hover:bg-[#071a2d] transition-all duration-300 group">
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-[#0EA5E9]/10 border border-[#0EA5E9]/15 mb-5 group-hover:bg-[#0EA5E9]/20 group-hover:border-[#0EA5E9]/30 transition-all duration-300">
                  <i className={`${item.icon} text-[#7DD3FC] text-xl`}></i>
                </div>
                <h3 className="font-['Inter'] text-white font-bold text-base mb-2">{item.title}</h3>
                <p className="font-['Inter'] text-white/50 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
          <div className="text-center">
            <Link
              to="/services"
              className="inline-flex items-center gap-2 border border-white/14 hover:border-[#0EA5E9]/50 hover:bg-[#0EA5E9]/8 text-white font-['Inter'] font-semibold text-sm px-7 py-3.5 rounded-lg transition-all duration-300 whitespace-nowrap"
            >
              View All Services <i className="ri-arrow-right-up-line"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Dallas Areas Covered + Map */}
      <section className="bg-[#050F1A] py-24">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <div>
              <p className="font-['Inter'] text-[#7DD3FC] text-xs font-semibold uppercase tracking-[0.18em] mb-4">Coverage</p>
              <h2 className="font-['Playfair_Display'] text-white text-4xl font-bold mb-6 leading-tight">
                Dallas Service Neighborhoods
              </h2>
              <p className="font-['Inter'] text-white/50 text-base leading-relaxed mb-8">
                Based in McKinney, our team provides HVAC services throughout Dallas and the greater metro area with fast, reliable response times.
              </p>
              <div className="flex flex-wrap gap-2.5 mb-8">
                {dallasAreas.map((area) => (
                  <div
                    key={area}
                    className="flex items-center gap-1.5 border border-white/8 text-white/58 font-['Inter'] text-sm px-4 py-2 rounded-full"
                  >
                    <div className="w-3 h-3 flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-fill text-[#7DD3FC] text-xs"></i>
                    </div>
                    {area}
                  </div>
                ))}
              </div>
              <div className="bg-[#071220] border border-white/6 rounded-xl p-5 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#0EA5E9]/10 flex-shrink-0">
                  <i className="ri-map-pin-2-line text-[#7DD3FC] text-lg"></i>
                </div>
                <div>
                  <div className="font-['Inter'] text-white font-bold text-sm mb-1">Our Location</div>
                  <address className="font-['Inter'] text-white/55 text-sm not-italic leading-relaxed">
                    833 Inwood Dr, McKinney, TX 75069
                  </address>
                  <a
                    href="tel:2148703185"
                    className="inline-flex items-center gap-1.5 text-[#7DD3FC] font-['Inter'] text-sm font-semibold mt-2 hover:text-white transition-colors duration-300"
                  >
                    <i className="ri-phone-fill text-xs"></i>
                    214-870-3185
                  </a>
                </div>
              </div>
            </div>
            {/* Map */}
            <div className="relative rounded-2xl overflow-hidden border border-white/6 h-[420px]">
              <iframe
                title="KISA Cooling Dallas Texas Service Area Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d429155.4736966424!2d-97.04396099039068!3d32.82010792378478!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c19f77b45974b%3A0xb9ec9ba4f647678f!2sDallas%2C%20TX!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
                className="absolute inset-0 w-full h-full"
                style={{ border: 0, filter: "invert(90%) hue-rotate(180deg) brightness(0.85) contrast(0.9)" }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      <AIAnswerBlock items={locationQA} title="Dallas AC Service — Quick Answers" />
      <MidPageCTA
        headline="Need AC Service in Dallas Today?"
        subtext="Same-day availability for urgent repairs across Dallas and the entire DFW metro area."
        ctaLabel="Schedule Dallas Service"
      />
      <ProcessSection />
      <WhyChooseUs />
      <TestimonialsSection />
      <QuoteForm />
      <FAQSection faqs={locationFaqs} title="Dallas AC Service FAQs" />
      <FinalCTA
        headline="Need AC Service in Dallas Today?"
        subheadline="Fast, professional cooling service across Dallas and the DFW metro. Same-day availability for urgent repairs."
        ctaLabel="Schedule Dallas Service"
        ctaHref="#quote"
      />
      <Footer />
    </main>
  );
}
